/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable max-len */
import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

import isEqual from 'lodash/isEqual';

import { getTransformedData, getTransformedRowData } from '../helpers/transformData';
import { mutateTree, moveItemOnTree } from '../helpers/tree';

import Tree from '../components/nestedRows';

const NestedRowsContainer = createReactClass({
  propTypes: {
    shouldPreventTransform: PropTypes.bool,
    isDragEnabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    isCombineEnabled: PropTypes.bool,
    isNestingEnabled: PropTypes.bool,
    className: PropTypes.string,
    data: PropTypes.shape({
      rootId: PropTypes.string,
      data: PropTypes.shape({
        rootId: PropTypes.string,
        items: PropTypes.objectOf(
          PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            hasChildren: PropTypes.bool,
            isExpanded: PropTypes.bool,
            isChildrenLoading: PropTypes.bool,
            data: PropTypes.shape({}),
            children: PropTypes.arrayOf(PropTypes.number),
          }),
        ),
      }),
    }),
    onDragStart: PropTypes.func,
    onDragEnd: PropTypes.func,
    renderComponent: PropTypes.func,
    containerHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    limitItemsToOriginalNestedDepth: PropTypes.bool,
    offsetPerLevel: PropTypes.number,
    shouldExpandOnNewChildren: PropTypes.bool,
    testId: PropTypes.string,
  },

  getDefaultProps() {
    return {
      shouldPreventTransform: true,
      isDragEnabled: true,
      isCombineEnabled: false,
      isNestingEnabled: false,
      className: '',
      data: {
        rootId: 'root',
        items: {
          root: {
            id: 'root',
            hasChildren: true,
            isExpanded: false,
            isChildrenLoading: true,
            data: { title: 'root' },
            children: [],
          },
        },
      },
      onDragStart: () => {},
      onDragEnd: () => {},
      renderComponent: () => {},
      containerHeight: 0,
      limitItemsToOriginalNestedDepth: false,
      offsetPerLevel: 16,
      shouldExpandOnNewChildren: false,
      testId: '',
    };
  },

  getInitialState() {
    return {
      tree: this.props.shouldPreventTransform
        ? this.props.data
        : getTransformedData(this.props.data),
    };
  },

  componentDidUpdate(prevProps) {
    // eslint-disable-next-line react/prop-types
    if (!isEqual(prevProps.data.items, this.props.data.items)) {
      this.setState({ tree: this.props.data });
    }
  },

  onExpand(itemId) {
    const { tree } = this.state;

    const mutatedTree = mutateTree(tree, itemId, { isExpanded: true });

    this.setState({ tree: mutatedTree });

    if (this.props.onExpand) {
      this.props.onExpand({ tree: mutatedTree });
    }
  },

  onCollapse(itemId) {
    const { tree } = this.state;

    const mutatedTree = mutateTree(tree, itemId, { isExpanded: false });

    this.setState({ tree: mutatedTree });

    if (this.props.onCollapse) {
      this.props.onCollapse({ tree: mutatedTree });
    }
  },

  onDragStart(result) {
    this.props.onDragStart(result);
  },

  onDragEnd(source, destination, sourcePath, destinationPath) {
    const { tree } = this.state;

    if (!destination) return;

    const { shouldExpandOnNewChildren } = this.props;

    const newTree = moveItemOnTree(tree, source, destination, shouldExpandOnNewChildren);

    this.setState({ tree: newTree });

    const rows = this.props.shouldPreventTransform ? newTree : getTransformedRowData(newTree);

    this.props.onDragEnd({
      source,
      destination,
      sourcePath,
      destinationPath,
      rows,
    });
  },

  render() {
    const { tree } = this.state;

    return (
      <Tree
        className={this.props.className}
        tree={tree}
        renderItem={this.props.renderComponent}
        renderCustomPlaceholder={this.props.renderCustomPlaceholder}
        onExpand={this.onExpand}
        onCollapse={this.onCollapse}
        onDragStart={this.onDragStart}
        onDragEnd={this.onDragEnd}
        onDragUpdate={() => null}
        offsetPerLevel={this.props.offsetPerLevel}
        containerHeight={this.props.containerHeight}
        isDragEnabled={this.props.isDragEnabled}
        isCombineEnabled={this.props.isCombineEnabled}
        isNestingEnabled={this.props.isNestingEnabled}
        limitItemsToOriginalNestedDepth={this.props.limitItemsToOriginalNestedDepth}
        testId={this.props.testId}
      />
    );
  },
});

export default NestedRowsContainer;
